export default __webpack_public_path__ + "static/media/truckSelected.aa4de406.svg";